import * as React from 'react';
import styled from 'styled-components';

import Checkbox from 'src/SharedComponents/Checkbox';

const Container = styled.label`
    display: flex;
    flex-direction: row;
    margin: 6px 4px;
    text-align: center;
    line-height: 1.1;
    justify-content: flex-end;
    flex: 1 1 auto;
`;

const AnswerContainer = styled.span`
    width: 200px;
    text-align: left;
`;

interface IProps {
    answer: string,
    checked: boolean,
    onChange: (isCheked: boolean) => void
};

const AlternateAnswerOption = (props: IProps) => {
    const { answer, checked, onChange } = props;
    return <Container style={{ alignItems: "center" }}>
        <AnswerContainer>{answer}</AnswerContainer>
        <Checkbox checked={checked} onChange={onChange} />
    </Container>;
};

export default AlternateAnswerOption;



// WEBPACK FOOTER //
// ./src/SharedComponents/AlternteAnswerOption.tsx